// import { useState, useRef } from "react";
// import { useSelector, useDispatch  } from "react-redux";
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-hot-toast'; // <-- Import toast
// import apiClient from "../../api/apiClient"; // Import the apiClient
// import { updateUser } from "../../redux/slices/authSlice"
// import "./index.css";

// const ProfilePage = () => {
//   const dispatch = useDispatch()
//   const user = useSelector((state) => state.auth?.user);
//   const [formData, setFormData] = useState({
//     name: user?.fullName || "",
//     email: user?.email || "",
//     phone: user?.phone || "",
//     birthday: user?.dob ? user?.dob.slice(0, 10) : "",
//     gender: user?.gender || "Male",
//   });

//   const [avatar, setAvatar] = useState(user?.userImage || "/placeholder.svg?height=96&width=96");
//   const fileInputRef = useRef(null);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     const fieldName = id.replace('profile-', '');

//     setFormData({
//       ...formData,
//       [fieldName]: value
//     });
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();

//       reader.onloadend = () => {
//         setAvatar(reader.result);  // The result will be a base64 string
//       };

//       reader.readAsDataURL(file);  // Convert the file to a base64 string
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const updatedUserData = { ...formData, userImage: avatar };

//     try {
//       const response = await apiClient.put(`/auth/user/${user._id}`, updatedUserData);

//       toast.success("Profile updated successfully!");

//       // 🔁 Update sessionStorage with new user data
//       const updatedUser = response.data?.user || updatedUserData;
//       sessionStorage.setItem("user", JSON.stringify(updatedUser));
//       dispatch(updateUser(updatedUserData)); // Dispatch the updateUser action to update the Redux store
//       navigate('/user-profile');
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       toast.error("Profile update failed. Please try again.");
//     }
//   };

//   return (
//     <section className="profil_page-main-container">
//       <div className="profile_page">
//         <div className="profile_page-header">
//           <h2 className="profile_page-title">Edit Profile</h2>
//           <p className="profile_page-description">Update your personal information.</p>
//         </div>

//         <form onSubmit={handleSubmit} className="position-relative">
//           <div className="profile_page-content">
//             <div className="avatar-container">
//               <div className="pc-avatar">
//                 <img src={avatar} alt="User Avatar" className="pc-avatar-image" />
//               </div>
//               <input
//                 type="file"
//                 ref={fileInputRef}
//                 onChange={handleFileChange}
//                 accept="image/*"
//                 style={{ display: 'none' }}
//               />
//               <button
//                 type="button"
//                 className="change-photo"
//                 onClick={() => fileInputRef.current.click()}
//               >
//                 Change Photo
//               </button>
//             </div>

//             <div className="form-group">
//               <label htmlFor="profile-name" className="form-labell">Name</label>
//               <input
//                 id="profile-name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="form-input"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="profile-email" className="form-labell">Email</label>
//               <input
//                 id="profile-email"
//                 type="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="form-input"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="profile-phone" className="form-labell">Phone</label>
//               <input
//                 id="profile-phone"
//                 type="tel"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 className="form-input"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="profile-birthday" className="form-labell">Birthday</label>
//               <input
//                 id="profile-birthday"
//                 type="date"
//                 value={formData.birthday}
//                 onChange={handleChange}
//                 className="form-input"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="profile-gender" className="form-labell">Gender</label>
//               <select
//                 id="profile-gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//                 className="form-input"
//                 required
//                 style={{
//                   boxShadow: '0 0 0 2px rgba(246, 197, 157, 0.3)',
//                   border: '1px solid #f6c59d'
//                 }}
//               >
//                 <option value="male">Male</option>
//                 <option value="female">Female</option>
//                 <option value="other">Other</option>
//               </select>
//             </div>

//           </div>

//           <div className="profile_page-footer">
//             <button type="button" onClick={() => navigate('/user-profile')} className="cancel-button">Cancel</button>
//             <button type="submit" className="save-button">Save Changes</button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default ProfilePage;


import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { LoaderCircle } from 'lucide-react';
import apiClient from "../../api/apiClient";
import { updateUser } from "../../redux/slices/authSlice";
import "./index.css";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: user?.fullName || "",
    email: user?.email || "",
    phone: user?.phone || "",
    birthday: user?.dob ? user?.dob.slice(0, 10) : "",
    gender: user?.gender || "Male",
  });

  const [avatar, setAvatar] = useState(user?.userImage || "/placeholder.svg?height=96&width=96");
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    const fieldName = id.replace('profile-', '');
    setFormData(prev => ({ ...prev, [fieldName]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setAvatar(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const updatedUserData = { ...formData, userImage: avatar };

    try {
      const response = await apiClient.put(`/auth/user/${user._id}`, updatedUserData);
      const updatedUser = response.data?.user || updatedUserData;

      sessionStorage.setItem("user", JSON.stringify(updatedUser));
      dispatch(updateUser(updatedUser));

      toast.success("Profile updated successfully!");
      navigate('/user-profile');
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Profile update failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="profil_page-main-container">
      <div className="profile_page">
        <div className="profile_page-header">
          <h2 className="profile_page-title">Edit Profile</h2>
          <p className="profile_page-description">Update your personal information.</p>
        </div>

        <form onSubmit={handleSubmit} className="position-relative">
          <div className="profile_page-content">
            <div className="avatar-container">
              <div className="pc-avatar">
                <img src={avatar} alt="User Avatar" className="pc-avatar-image" />
              </div>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept="image/*"
                style={{ display: 'none' }}
              />
              <button
                type="button"
                className="change-photo"
                onClick={() => fileInputRef.current.click()}
              >
                Change Photo
              </button>
            </div>

            {["name", "email", "phone", "birthday"].map((field) => (
              <div className="form-group" key={field}>
                <label htmlFor={`profile-${field}`} className="form-labell">
                  {field.charAt(0).toUpperCase() + field.slice(1)}
                </label>
                <input
                  id={`profile-${field}`}
                  type={field === "email" ? "email" : field === "birthday" ? "date" : "text"}
                  value={formData[field]}
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>
            ))}

            <div className="form-group">
              <label htmlFor="profile-gender" className="form-labell">Gender</label>
              <select
                id="profile-gender"
                value={formData.gender}
                onChange={handleChange}
                className="form-input"
                required
                style={{
                  boxShadow: '0 0 0 2px rgba(246, 197, 157, 0.3)',
                  border: '1px solid #f6c59d'
                }}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="profile_page-footer">
            <button
              type="button"
              onClick={() => navigate('/user-profile')}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-button"
              disabled={loading}
            >
              {loading ? (
                <span>
                  <LoaderCircle className="spin-loader" size={20} />
                  Saving...
                </span>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ProfilePage;
